(() => {
  if (window.SambaSuggestionReady) return;
  window.SambaSuggestionReady = true;
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-samba-suggestion-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.sambaSuggestionOpen);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }
    const close = event.target.closest('[data-samba-suggestion-close]');
    if (close) close.closest('dialog')?.close();
  });
  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });
})();